<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.school.schoolAdd') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :rules="schoolNameRules"
                                :label="$vuetify.lang.t('$vuetify.custom.school.schoolName')+'*'"
                                v-model="formData.name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules="nickNameRules"
                                :label="$vuetify.lang.t('$vuetify.custom.school.nickName')+'*'"
                                v-model="formData.nickName"
                            ></v-text-field>
                        </v-col>
<!--                        <v-col cols="12">-->
<!--                            <v-text-field-->
<!--                                :label="$vuetify.lang.t('$vuetify.custom.school.userName')+'*'"-->
<!--                                v-model="formData.userName"-->
<!--                            ></v-text-field>-->
<!--                        </v-col>-->
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.addBtn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
    export default {
        name: 'school-add',
        model: {
            prop: 'addDialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean
        },
        data: () => ({
            formData: {
                name: '',
                nickName: '',
                userName: ''
            },
            rules: {
                required: value => !!value || '请输入'
            },
            schoolNameRules:[
                v => !!v || '学校名称必填',
                v => v.length <= 20 || '学校名称最长不能超过20个字',
            ],
            nickNameRules:[
                v => !!v || '简称必填',
                v => v.length <= 4 || '简称最长不能超过4个字',
            ],

        }),
        methods: {
            hiddenDialog() {
                this.$emit('parent-event', false);
                this.$refs.form.reset()
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.$api.school.addSchool(this.formData).then(data => {
                        if (data.flag) {
                            this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                            this.$emit('initialize')
                            this.hiddenDialog();
                        } else {
                            this.$dialog.alert(data.msg)
                            this.$refs.form.reset()
                        }
                    })
                }
            }
        },
    }
</script>
